import { loadMicroApp } from 'qiankun';
class QiankunClass {
    loadMicroApp = loadMicroApp;
    // 主应用传入loadMicroApp时，使用主应用的
    setLoadMicroAppFn(callback?: any) {
        if (callback) this.loadMicroApp = callback;
    }
}

export const qiankunClassExample = new QiankunClass();
